import { Component, effect, inject } from '@angular/core';
import { SafeUrl } from '@angular/platform-browser';
import { UserPhotoService } from '@core/service/user-photo.service';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-user-photo',
    templateUrl: './user-photo.component.html',
    styleUrls: ['./user-photo.component.scss'],
    imports: [
        TranslatePipe,
    ],
})
export class UserPhotoComponent {
    private _userPhotoService = inject(UserPhotoService);

    imageSource: SafeUrl | null = null;

    constructor() {
        this.setEffects();
    }

    private setEffects(){
        effect(() => {
            this.imageSource = this._userPhotoService.imageSource();
        });
    }
}